'use strict';
window.NA = window.NA || {};

window.NA.Ajax = (function($) {
  /**
   * Creates a JSend response handler.
   * 
   * @param fnSuccess (optional) Callback for 'success' responses
   * @param fnFail (optional) Callback for 'error' or 'fail' responses.  Set to null if you don't want errors written to the error container
   */
  function getResponseHandler(fnSuccess, fnFail) {
    return function(jqXHR, status) {
      var responseText = jqXHR.responseText;
      var response = responseText && JSON.tryParse(responseText);
      fnFail = (fnFail !== undefined) ? fnFail : null;

      if (!response) {
        console.error('Invalid response status', jqXHR);
        console.trace();
        fnFail && fnFail(null);
        return null;
      }

      let jsendStatus = response.status;

      if (jsendStatus === 'error') {
        if (fnFail) { fnFail(response, jqXHR, status); }
        else { console.error("Server error occurred.", response); }
      }
      else if (jsendStatus === 'fail') {
        if (fnFail) { fnFail(response, jqXHR, status); }
        else { console.error("Client error occurred.", response); }
      }
      else if (jsendStatus === 'success') {
        fnSuccess && fnSuccess(response.data, jqXHR, status);
      }
      else {
        console.error('Unexpected response status', jqXHR);
        console.trace();
        fnFail && fnFail(null);
      }
    };
  }
  
  /**
   * Return human-readable error message (suitable for client display) from JSend response
   */
  function errorFromResponse(response) {
    if (!response || !response.status) {
      return "Error: Invalid server response";
    }
    
    switch (response.status) {
    case 'success': 
      return null;
    case 'fail':
      if (response.data) {
        if (typeof(response.data) == 'string') { 
          return response.data;
        }
        else if (response.data.message) { 
          return response.data.message;
        }
        else if (response.data.code) {
          return "Error: " + response.data.code;
        }
      }
      return "Error: Bad request";
    case 'error':
      return response.message || "Error on server";
    default:
      return "Invalid response from server";
    }
  }
  
  function dataFromForm($form) {
    var data = new FormData();
    
    $('input, textarea, select', $form).each(function (idx, el) {
      var $el = $(el);
      var name = $el.attr('name');
      if (!name) { return; }
      
      var type = $el.attr('type');

      // Skip unchecked checkboxes and radios
      if (type === 'checkbox' || type === 'radio') {
        if(!$el.prop('checked')) { return; } 
      }
      
      var val = $el.val();
      data.append(name, val);

      if ($el.attr('type') && $el.attr('type').toLowerCase() == 'file') {
        var files = $el[0].files;
        
        for (var i = 0; i < files.length; i++) {
          var fieldName = (files.length > 1 ? (name + ':' + i) : name);
          data.append(fieldName, files[i]);
        }
      }
    });
    
    return data;
  }

  function post(strAction, params, onSuccess, onFail) {
    return request('post', strAction, params, onSuccess, onFail);
  }
  
  function get(strAction, params, onSuccess, onFail) {
    return request('get', strAction, params, onSuccess, onFail);
  }
  
  /**
   * GETs a specified AJAX endpoint.
   * 
   * A nonce (pt-opNonce) is automatically appended to the form if there's an input anywhere
   * with the id 'pt-opNonce'. 
   */
  function request(method, strAction, params, onSuccess, onFail) {
    var data = $.extend({}, params);
    data['action'] = strAction;
    
    if (!data['nonce']) {
      var $nonce = $('input#pt-opNonce');
      
      if ($nonce.length) {
        data['pt-opNonce'] = $nonce.val();
      }
    }
    
    $.ajax({
      url: NASystem.ajaxUrl,
      method: method,
      data: data,
      complete: getResponseHandler(onSuccess, onFail),
      xhrFields: { withCredentials:true }
    });
  }    
    
  /**
   * Post the contents of the form to the specified AJAX action.
   * 
   * A nonce (na-opNonce) is automatically appended to the form if there's an input anywhere
   * with the id 'na-opNonce'. 
   */
  function postForm($form, strAction, onSuccess, onFail) {
    var data = dataFromForm($form);
    data.append('action', strAction);
    
    if (!data.has('nonce')) {
      var $nonce = $('input#na-opNonce');
      
      if ($nonce.length) {
        data.append('na-opNonce', $nonce.val());
      }
    }
    
    $.ajax({
      url: NASystem.ajaxUrl,
      method: 'post',
      data: data,
      processData: false,
      contentType: false,
      complete: getResponseHandler(onSuccess, onFail),
      xhrFields: { withCredentials:true }
    });
  }    

  /**
   * Checks for form fields with the :invalid pseudoclass (indicating they contain the wrong
   * type or are empty when required).  Activates the .validation-failed class if necessary.
   * 
   * @return true if the form is valid
   */
  function validateForm($form, fnOnErrorClose) {
    if ($form.find(':invalid').length == 0) {
      return true;
    }
     
    $form.addClass('validation-failed');
    return false;
  }
    
  return {
    dataFromForm: dataFromForm,
    errorFromResponse: errorFromResponse,
    get: get,
    post: post,
    getResponseHandler: getResponseHandler,
    postForm: postForm,
    validateForm: validateForm
  };
})(jQuery);